import apiClient from "../utils/axiosInterceptor"; // Import the axiosInterceptor


export const getAISuggestionPowerPositionAPI = async (payload: any) => {
    try {
        const response = await apiClient.post(`/fapp-ai-api/api/AISearchHandler`, payload);
        return response;
    } catch (error: any) {
        console.error('Error fetching:', error);
        return error.response?.status || 500;
    }
}


export const getPowerPositionListAPI = async () => {
    try {
        const response = await apiClient.get(`/fapp-core-api/api/PowerPosition`);
        return response;
    } catch (error: any) {
        console.error('Error fetching:', error);
        return error.response?.status || 500;
    }
}

function parseJsonIfValid(value: any): any {
    if (value === "" || value === null) return null;
    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
}

function getOrDefault(obj: any, key: string, defaultValue: any) {
    return obj?.[key] ?? defaultValue;
}

function getStringOrEmpty(obj: any, key: string) {
    return obj?.[key] || "";
}

function getNumberOrZero(obj: any, key: string) {
    return obj?.[key] || 0;
}

export const saveNegotiationFormsDataOnDetailedOverviewAPI = async (data: any) => {
    if (!data) return 400;

    try {
        const { basicDetailsData, powerPositionDetails, othersData, TargetValueData, salesRepClassificationData, PlanNegotiationActions, isFormUpdate } = data;

        const finalData = {
            Name: getStringOrEmpty(basicDetailsData, "negotiationName"),
            LeadCountryId: getStringOrEmpty(basicDetailsData, "leadCountry"),
            CategoryId: getStringOrEmpty(basicDetailsData, "categoryName"),
            AdditionalSalesRep: getStringOrEmpty(basicDetailsData, "additionalSalesRep"),
            NegotiationTeam: getStringOrEmpty(basicDetailsData, "negotiationTeam"),
            OD: getStringOrEmpty(basicDetailsData, "od"),
            SupplierId: getStringOrEmpty(basicDetailsData, "suppliers"),
            SalesRepLeadId: getStringOrEmpty(basicDetailsData, "salesRepLead"),
            NegotiationDateMonth: getNumberOrZero(basicDetailsData, "negotiationDateMonth"),
            NegotiationDateYear: getNumberOrZero(basicDetailsData, "negotiationDateYear"),
            NegotiationImplementationMonth: getNumberOrZero(basicDetailsData, "negotiationImplementationMonth"),
            NegotiationImplementationYear: getNumberOrZero(basicDetailsData, "negotiationImplementationYear"),
            ValidityPeriod: getNumberOrZero(basicDetailsData, "validityPeriod"),
            RelevantSpend: getNumberOrZero(basicDetailsData, "relevantSpend"),
            Comment: basicDetailsData?.comment,
            PowerPositionQuestion1: parseJsonIfValid(powerPositionDetails?.powerPositionData?.supplierExistOrNot),
            PowerPositionQuestion2: parseJsonIfValid(powerPositionDetails?.powerPositionData?.supplierAwareness),
            PowerPositionQuestion3: parseJsonIfValid(powerPositionDetails?.powerPositionData?.supplierDependent),
            powerPositionTitle: powerPositionDetails?.powerPosition,
            PowerPositionID: powerPositionDetails?.powerPositionId,
            IsSavedForLater: othersData?.isSavedForLater !== false,
            Status: othersData?.status,
            SupplyDemandBalance: getStringOrEmpty(TargetValueData, "supplyDemand"),
            PrecursorCostChanges: getNumberOrZero(TargetValueData, "precursorCostChange"),
            NegotiationTarget: getNumberOrZero(TargetValueData, "NegotiationTarget"),
            StopLimit: getNumberOrZero(TargetValueData, "stopLimit"),
            GoinPosition: getNumberOrZero(TargetValueData, "goInPosition"),
            NegotiationRounds: getNumberOrZero(TargetValueData, "rounds"),
            PaymentTerms: getStringOrEmpty(TargetValueData, "paymentTerms"),
            IncoTerms: getStringOrEmpty(TargetValueData, "incoTerms"),
            LocalStock: getStringOrEmpty(TargetValueData, "localStock"),
            SummaryDetails: "Summary includes supplier history, current terms, and expectations.",
            ClassificationSettings: salesRepClassificationData?.classificationSettings
                ? JSON.stringify(salesRepClassificationData.classificationSettings)
                : "",
            salesRepClassificationTitle: salesRepClassificationData?.classificationType || "",
            SalesRepClassificationID: salesRepClassificationData?.salesRepClassificationId || "",
            NegotiationRoundsDetails: PlanNegotiationActions
        };

        const response = isFormUpdate?.state
            ? apiClient.put(`fapp-core-api/api/Negotiation`, { ID: isFormUpdate.ID, ...finalData })
            : apiClient.post(`fapp-core-api/api/Negotiation`, finalData);

        return response;
    } catch (error: any) {
        console.error("Error sending negotiation data:", error);
        return error.response?.status || 500;
    }
};